import { create } from 'zustand'

export type Lang = 'en' | 'fr'

interface I18nState {
  lang: Lang
  setLang: (l: Lang) => void
}

const STORAGE_KEY = 'zeus-lang'

function initial(): Lang {
  if (typeof window === 'undefined') return 'en'
  const stored = window.localStorage.getItem(STORAGE_KEY) as Lang | null
  if (stored === 'en' || stored === 'fr') return stored
  // Default from browser
  const nav = window.navigator.language?.toLowerCase() ?? 'en'
  return nav.startsWith('fr') ? 'fr' : 'en'
}

export const useI18n = create<I18nState>((set) => ({
  lang: initial(),
  setLang: (l) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, l)
    }
    set({ lang: l })
  },
}))
